export const breakpointNames = ['mobile', 'tablet', 'desktop'] as const;

export const breakpoints = {
  mobile: 0, // 0 - 767
  tablet: 768, // 768 - 991
  desktop: 992, // 992 - ∞
} as const;

export type Breakpoint = keyof typeof breakpoints;
